export const SUBSCRIPTION_FEATURES = [
  "clients.manage", "measurements.manage", "orders.manage", "order_tracking.use",
  "styles.manage", "payments.manage", "receipts.generate", "finance.view",
  "whatsapp_automation.use", "offline_sync.use", "data_export.use", "workers.manage",
  "workers.accounts.manage", "tasks.assign", "workers.commissions.manage",
  "workers.salaries.manage", "teams.permissions.manage", "teams.reports.view", "branches.manage"
] as const;

export type SubscriptionFeature = (typeof SUBSCRIPTION_FEATURES)[number];
export type SubscriptionEntitlements = {
  plan: "beta" | "pro" | "teams";
  features: Record<string, boolean>;
};

export function canonicalPlan(status: string | null | undefined): SubscriptionEntitlements["plan"] {
  if (status === "beta") return "beta";
  if (status === "teams" || status === "atelier") return "teams";
  return "pro";
}

export function fallbackEntitlements(status: string | null | undefined): SubscriptionEntitlements {
  const plan = canonicalPlan(status);
  const proFeatures = [
    "clients.manage", "measurements.manage", "orders.manage", "order_tracking.use", "styles.manage",
    "payments.manage", "receipts.generate", "finance.view", "whatsapp_automation.use", "offline_sync.use", "data_export.use"
  ];
  const features = Object.fromEntries(SUBSCRIPTION_FEATURES.map((feature) => [feature, plan === "teams" || plan === "beta" || proFeatures.includes(feature)]));
  return { plan, features };
}

export function canUseFeature(entitlements: SubscriptionEntitlements | null | undefined, feature: SubscriptionFeature): boolean {
  return Boolean(entitlements?.features[feature]);
}
